<template>
  <div class="concierce_wrapper" ref="wrapper__element">
    <!-- contents-->
    <div class="contents">
      <div class="voucher_post_box">
        <div class="voucher_post">
          <!-- S : 20250512 수정(ASB-12562) -->
          <div class="voucher_post-img">
            <img src="./images/concierce_voucher_mo.png" alt="DIAMOND CONCIERGE PHYTO CAFE 음료 바우처">
          </div>
          <div class="voucher_post-info medium"> <!-- class: 'medium' 추가  -->
            <div class="voucher_post-text">
              <div class="voucher_post-amount">
                <span>{{ totalCouponSum }}</span> 매
              </div>
            </div>
          </div>
          <!-- E : 20250512 수정(ASB-12562) -->
        </div>
      </div>

      <!-- S : 20250513 수정(ASB-12562) -->
      <infotagUse :expDate="endDate"/>
      <!-- E : 20250513  -->

      <div class="voucher_greet" v-show="isProud">
        <p class="greet_sub">“I’M PROUD OF YOU”</p>
        <p class="greet_txt">당신이 자랑스럽습니다.</p>
        <div class="greet_sender">
          <span class="sender">{{ aboName }}</span>님이 보내신 선물입니다.
        </div>
      </div>
      <div class="voucher_coupon_agree_box" v-show="!isNext">
        <div class="voucher_coupon_agree">
          <div class="coupon_agree_all">
            <input type="checkbox" @change="checkedAll($event)" v-model="allChecked" id="form_agree_all_coupon" class="form_agree" ref="agree__element">
            <label for="form_agree_all_coupon">파이토 카페 음료 바우처 이용약관 동의</label>
          </div>
          <div class="coupon_agree_detail">
            <div class="coupon_agree_detail_inner">
              <input type="checkbox" @change="check($event)" v-model="checkList[0]" id="form_agree_1" class="form_agree">
              <label for="form_agree_1">[필수] 파이토 카페 음료 바우처 이용동의</label>
              <a @click="termsPopup(true,'voucher')" class="agree_detail_pop" data-layer="voucher-agree-layer">자세히 보기</a>
            </div>
            <div class="coupon_agree_detail_inner">
              <input type="checkbox" @change="check($event)" v-model="checkList[1]" id="form_agree_2" class="form_agree">
              <label for="form_agree_2">[필수] 개인정보 수집 및 이용동의</label>
              <a @click="termsPopup(true,'personal')" class="agree_detail_pop" data-layer="personal-agree-layer">자세히 보기</a>
            </div>
          </div>
        </div>
      </div>

      <!-- S : 직원 확인 버튼 클릭 시 노출 -->
      <!-- S: ASB-12562 추가 -->
      <counter
        v-show="exchange"
        text="사용"
        ref="counter__component"
        :totalCouponSum="totalCouponSum"
      />
      <!-- E: ASB-12562 -->

      <!-- <div class="voucher_contact"> -->
      <div class="voucher_contact" v-show="exchange">
        <p>매장 선택 후, 직원 확인용 비밀번호를 입력해주세요.</p>
        <div class="contact_tel">
          <div class="contact_tel_1">
            <select class="form-tel" title="ABC 지역 입력" @change="selectBoxChange($event)">
              <option :key="i" :value="storeInfo.store_code" v-for="(storeInfo,i) in storeInfo">{{ storeInfo.store_name }} ABC</option>
            </select>
          </div>
          <div class="contact_tel_2">
            <input v-model="pinNum" type="password" class="form-tel" placeholder="****" title="비밀번호 입력" ref="pw__element">
          </div>
        </div>
      </div>
      <!-- E : 직원 확인 버튼 클릭 시 노출 -->

      <div class="concierce_btn_area">
        <!-- 바우처 교환 전 case-->
        <button type="button" class="btn-pop-submit"  v-show="exchange" v-on:click="exchangeCoupon()">바우처 교환 완료 처리</button>
        <!-- 바우처 교환 완료 case -->
        <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
        <!-- 바우처 사용 기한 만료 case -->
        <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
      </div>

      <div class="concierce_btn_area">
        <button type="button" class="btn-pop-submit" v-show="!isNext" v-on:click="next()">이용동의 및 직원확인</button>
        <button type="button" class="btn-pop-submit" v-show="isCancel" disabled>회수된 바우처</button>
        <button type="button" class="btn-pop-submit" v-show="expired" disabled  style="display:none">사용 기한 만료</button>
        <!-- 바우처 교환 완료 case -->
        <button type="button" class="btn-pop-submit" v-show="exchangeSuccess" v-bind:disabled="exchangeSuccess">교환 완료</button>
      </div>
    </div>

    <!-- S : 20220816 바우처 이용 동의 팝업 -->
    <div id="voucher-agree-layer" class="layer-area layer_section type-narrow-b"  :class="{showing:popupFlag1}" >
      <div class="layer_section-container">
        <div class="layer-content">
          <!-- S : 20221005 수정-->
          <div class="agree-area">
            <div class="agree-title-area">
              <h1 class="agree-title">파이토 카페 음료 바우처 이용동의</h1>
            </div>
            <div class="agree-content">
              <ol>
                <li>파이토 카페 음료 바우처는 한국암웨이 다이아몬드 이상 리더에게 제공되는 다이아몬드 컨시어지 혜택입니다.</li>
                <li>다이아몬드 컨시어지 혜택자에게 선물받은 바우처는 판매가 불가능하며, 소비자로서 최종 소비만 가능합니다.</li>
                <li>이용기한내에 바우처를 사용하시길 권장드립니다.</li>
                <li>바우처 이용기한내 미사용 시, 분실 시 재발급 불가합니다.</li>
                <li>바우처가 포함된 메시지 삭제 시 재발송 불가합니다.</li>
              </ol>
            </div>
          </div>
          <!-- E : 20221005 수정-->
        </div>
        <div class="align-box size-auto">
          <button @click="termsPopup(false,'voucher')" type="button" class="btn-modal_close">확인</button>
        </div>
      </div>
    </div>
    <!-- E : 20220816 바우처 이용 동의 팝업 -->

    <!-- S : 20220816 개인정보수집및이용동의 팝업 -->
    <div id="personal-agree-layer" class="layer-area layer_section type-narrow-b" :class="{showing:popupFlag2}">
      <div class="layer_section-container">
        <div class="layer-content">
          <div class="agree-area">
            <div class="agree-title-area">
              <h1 class="agree-title">개인정보 수집 및 이용동의</h1>
            </div>
            <div class="agree-content">
              <p>한국암웨이㈜는 다이아몬드 컨시어지 파이토 카페 음료 바우처 제공을 위하여 다음과 같이 귀하의 개인정보를 수집 및 이용합니다.</p>
              <ul class="agree-list">
                <li>
                  수집하는 개인정보 항목
                  <span>성명, 전화번호</span>
                </li>
                <li>
                  개인정보의 수집 및 이용목적
                  <span>파이토 카페 음료 바우처 발행</span>
                </li>
                <li>
                  개인정보의 보유 및 이용기간
                  <span>동의일로부터 6개월</span>
                </li>
              </ul>
              <p>※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 다이아몬드 컨시어지 파이토 카페 음료 바우처 혜택은 제공되지 않습니다.</p>
            </div>
          </div>
        </div>
        <div class="align-box size-auto">
          <button @click="termsPopup(false,'personal')" type="button" class="btn-modal_close">확인</button>
        </div>
      </div>
    </div>
    <!-- E : 20220816 개인정보수집및이용동의 팝업 -->
  </div>
</template>

<script>
// Component
import counter from './component/counter.vue'
import infotagUse from './component/infotagUse.vue'
// Library
import axios from 'axios'

export default {
  metaInfo: {
    title: '다이아몬드 컨시어지 파이토 카페 바우처 선물하기',
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'keywords' },
      { name: 'description', content: 'NY Fee Bundle' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:description', content: '한웨이님이 선물하신 ABC 파이토 카페 음료 바우처를 사용해 보세요.' },
      { property: 'og:image', content: './images/concierce_kakao_thumb.png' }
    ]
  },
  name: 'giftCoupon',
  components: {
    counter, // ASB-12562 추가
    infotagUse // ASB-12562 추가
  },
  data () {
    return {
      isConfirm: true,
      isExchanged: false,
      isExchangeSuccess: false,
      isExpired: false,
      ready: false,
      storeInfo: [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}],
      cpNo: '', // ASB-12562 추가
      cpInfo: [], // ASB-12562 추가
      totalCouponSum: 0, // ASB-12562 추가
      endDate: '',
      storeCode: '',
      pinNum: '',
      checkList: [false, false],
      allChecked: false,
      isNext: false,
      isProud: true,
      isCancel: false,
      aboName: '한국암웨이',
      popupFlag1: false,
      popupFlag2: false,
      inProgress: false
    }
  },
  computed: {
    confirm () {
      return this.isConfirm
    },
    exchange () {
      return this.isExchanged
    },
    exchangeSuccess () {
      return this.isExchangeSuccess
    },
    expired () {
      return this.isExpired
    }
  },
  methods: {
    init: function () { // 초기화
      // storeInfo
      this.storeInfo = [{id: '', store_code: '', store_name: '', pin_num: '', modified_by: '', modified_date: '', created_by: '', created_date: ''}]
      // button visibility
      this.isConfirm = false
      this.isExchanged = false
      this.isExchangeSuccess = false
      this.isExpired = false
      this.getStoreInfo()
    },
    termsPopup: function (flag, what) {
      if (what === 'voucher') {
        this.popupFlag1 = flag
      } else if (what === 'personal') {
        this.popupFlag2 = flag
      }
      if (flag) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
    // 체크박스 전체선택 해제 start
    checkedAll: function (e) {
      this.allChecked = e.target.checked
      for (let i in this.checkList) {
        this.checkList[i] = this.allChecked
      }
    },
    check: function () {
      for (let i in this.checkList) {
        if (!this.checkList[i]) {
          this.allChecked = false
          return
        } else {
          this.allChecked = true
        }
      }
    },
    // 체크박스 전체선택 해제 end
    next: function () {
      // 약관 미확인 시 넘어가지 않음
      for (let i in this.checkList) {
        if (!this.checkList[i]) {
          alert('바우처 사용 동의 약관을 확인해주세요.')
          this.$refs.agree__element.focus()
          return
        }
      }
      this.isNext = true
      this.isProud = false
      this.isExchanged = true
      // S: ASB-12562 변경: jQuery 제거
      setTimeout(() => {
        this.$refs.wrapper__element.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'end'})
      }, 100)
      // E: ASB-12562 변경
    },
    selectBoxChange: function (event) {
      this.storeCode = event.target.value
    },
    exchangeCoupon: async function () {
      if (this.inProgress === false) {
        this.inProgress = true
        if (this.pinNum === '') {
          alert('비밀번호를 입력하여 주십시오.')
          this.$refs.pw__element.focus()
        } else {
          await axios.post(
            process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-useCoupon',
            {
              scid: this.cpNo,
              tuid: '',
              store_cd: this.storeCode,
              pin_num: this.pinNum,
              gift: 'gift',
              use_count: this.$refs.counter__component.selectedCP, // ASB-12562 수정
              created_by: 'SYSTEM',
              modified_by: 'SYSTEM'
            },
            {headers: {'Content-Type': 'application/json;charset=UTF-8'}
            }).then(response => {
            // console.log('response : ', JSON.stringify(response, null, 2))
            if (response.data.statusCode === 200) {
              const confirmResult = JSON.parse(response.data.results)
              // console.log(this.confirmResult[0].resultCode)
              // S: ASB-12562 변경: if -> switch, code 추가
              switch (confirmResult[0].resultCode) {
                case 'SUCCESS':
                  alert('교환 완료')
                  window.location.reload()
                  break
                case 'STORE INVALID':
                  alert('store invalid')
                  break
                case 'PIN FAULT':
                  alert('비밀번호를 다시 확인해주세요.')
                  this.$refs.pw__element.focus()
                  break
                case 'COUPON 0':
                case 'COUPON Not Enough':
                case 'COUPON May Not Enough':
                  alert('쿠폰 보유수량이 부족합니다.')
                  window.location.reload()
                  break
                case 'COUPON EXPIRED':
                  alert('유효기간이 만료 되었습니다.')
                  window.location.reload()
                  break
                default:
                  alert('Fail to use voucher')
              }
              // E: ASB-12562 변경
            } else {
              alert('500: Fail to use voucher')
            }
          }).catch(error => {
            console.log('error : ', error)
            alert('잠시후 다시 시도 부탁드립니다.')
          })
        }
      }
      this.inProgress = false
    },
    // store정보
    getStoreInfo: function () {
      axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-myCoupon',
        {
          scid: this.cpNo,
          tuid: ''
        },
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}
        }).then(response => {
        // console.log('response : ', JSON.stringify(response, null, 2))
        if (response.data.statusCode === 200) {
          this.storeInfo = JSON.parse(response.data.storeList)
          if (this.storeInfo.length > 0) {
            this.storeCode = this.storeInfo[0].store_code
          }
          this.cpInfo = JSON.parse(response.data.couponInfo)
          if (this.cpInfo.length > 0) {
            this.aboName = this.cpInfo[0].abo_name
            this.endDate = this.cpInfo[0].end_date
            // S: ASB-12562 변경: 쿠폰 여러장 받을 시, 회수 기능은 사용하지 않고 있음
            this.totalCouponSum = this.cpInfo.filter(item => item.use_yn === 'N').length
            // this.use_yn = this.cpInfo[0].use_yn
            // if(this.use_yn == 'C'){
            //     //회수된 바우처 처리
            //     this.isCancel = true
            //     this.isNext = true
            //     this.isProud = false
            // }else if(this.use_yn == 'Y'){
            //     this.isExchangeSuccess = true
            //     this.isNext = true
            //     this.isProud = false
            // }
            if (this.totalCouponSum === 0) {
              this.isExchangeSuccess = true
              this.isNext = true
              this.isProud = false
            }
            // E: ASB-12562 변경
          } else {
            alert('존재하지 않는 바우처입니다.')
            window.location.href = process.env.AMWAY_ROOT_URL
          }
          // this.endDate = '2022-12-18 10:35:44'
          const expYear = this.endDate.substring(0, 4)
          const expMonth = this.endDate.substring(5, 7)
          const expDate = this.endDate.substring(8, 10)
          // 연도, 월, 일 추출
          const jsDate = new Date()
          const cpDate = new Date(expYear, expMonth - 1, expDate)
          const nowDate = new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())
          // 유효기간 만료시 버튼 처리
          if (cpDate >= nowDate) {
            this.isExpired = false
          } else {
            this.isExpired = true
            this.isConfirm = false
            this.isExchanged = false
            this.isExchangeSuccess = false
            this.isNext = true
            this.isCancel = false
          }
        } else {
          alert('Fail to load store info')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('잠시후 다시 시도 부탁드립니다.')
      })
    }
  },
  mounted () {
    window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 100)
  },
  created () {
    this.cpNo = this.$route.params.cpNo
  }
}
</script>

<style>
    @import './css/concierce.css';
</style>



// WEBPACK FOOTER //
// src/views/concierge/giftCoupon.vue